import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import DirectorBanner from "../../Assets/directormsg.jpg";
import directorImg1 from "../../Assets/image1.jpg";
import directorImg from "../../Assets/image2.jpg";
import { Link } from "react-router-dom";

const DirectorsMessage = () => {
  return (
    <div>
      <Header />

      {/* banner section start */}
      <section
        className="container-fluid common_banner"
        style={{
          backgroundImage: `url(${DirectorBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <div className="common_title wow fadeInUp">
                <h2>
                  <Link
                    to="/AboutUs"
                    className="text-decoration-none text-white"
                  >
                    ABOUT US
                  </Link>{" "}
                  <span className="text-white">/ Director’s Message</span>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* banner section end */}

      {/* director message section start */}
      <section className="container-fluid about_Products_section py-5">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Side Image */}
            <div className="col-lg-2 col-md-12 col-sm-12 mb-4 wow fadeInLeft">
              <div className="director_img text-center">
                <img
                  src={directorImg1}
                  alt="Director"
                  className="img-fluid rounded shadow"
                  style={{
                    maxHeight: "500px",
                    objectFit: "cover",
                  }}
                />
              </div>
            </div>
            <div className="col-lg-2 col-md-12 col-sm-12 mb-4 wow fadeInLeft">
              <div className="director_img text-center">
                <img
                  src={directorImg}
                  alt="Director"
                  className="img-fluid rounded shadow"
                  style={{
                    maxHeight: "500px",
                    objectFit: "cover",
                  }}
                />
              </div>
            </div>

            {/* Right Side Content */}
            <div className="col-lg-8 col-md-12 col-sm-12 wow fadeInRight">
              <div className="blog_text">
                <h5
                  style={{
                    color: "#153fa4",
                    fontFamily: "Segoe UI, sans-serif",
                    fontSize: "40px",
                    fontWeight: "700",
                    marginBottom: "20px",
                  }}
                >
                  Director’s Message
                </h5>

                <p>
                  Glass has always played a vital role in shaping modern infrastructure and transportation. Over the years, it has evolved from being just a functional material to becoming an essential component that combines safety, durability, innovation, and aesthetics.
                </p>

                <p>
                  It gives us immense pleasure to introduce Khodiyar Automotive Glass Pvt. Ltd., a trusted name in the field of automotive, commercial vehicle, and specialized glass solutions. Our journey began in 2015 with the establishment of Khodiyar Industries at Mehsana, Gujarat. Through continuous growth, technological advancement, and an unwavering commitment to quality, we expanded our vision and, in 2021, strengthened our presence as Khodiyar Automotive Glass Pvt. Ltd.
                </p>

                <p>
                  Today, Khodiyar Automotive Glass Pvt. Ltd. specializes in manufacturing premium-quality Automotive Toughened Glass, Laminated Glass, Tempered Glass, Commercial Vehicle Glass, Home Appliance Glass, Architectural Glass, and customized glass solutions designed to meet diverse industry requirements.
                </p>

                <p>
                  At Khodiyar Automotive Glass Pvt. Ltd., quality remains at the core of everything we do. Our products are manufactured using premium-grade raw materials and advanced processing technologies, ensuring superior strength, safety, durability, scratch resistance, and excellent finish.
                </p>

                <p>
                  Backed by a modern manufacturing facility, skilled workforce, and customer-focused approach, we continuously strive to deliver reliable products, timely service, and complete customer satisfaction.
                </p>

                <p>
                  As industries continue to evolve, we remain committed to innovation, operational excellence, and long-term partnerships. Our goal is not only to manufacture world-class glass products but also to become a dependable partner for our customers by understanding their needs and exceeding expectations.
                </p>

                <p>
                  We sincerely thank our customers, business associates, and partners for their continued trust and support. We look forward to growing together and building a stronger future through quality, innovation, and dedication.
                </p>

                <h6
                  style={{
                    marginTop: "30px",
                    fontWeight: "700",
                    color: "#153fa4",
                    fontSize: "22px",
                  }}
                >
                  Yours sincerely,
                </h6>

                <p style={{ marginBottom: "0px", fontWeight: "600" }}>
                  Mr. Niraj Patel & Mr. Laxman Patel
                </p>

                <p style={{ color: "#555" }}>
                  (Directors) <br />
Khodiyar Automotive Glass Pvt. Ltd.                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* director message section end */}

      <Footer />
    </div>
  );
};

export default DirectorsMessage;
